import { observer } from 'mobx-react'
import { useContext } from 'react'
import { StoreContext } from '@store/Root.store'
import { Header } from '@/components/Generic'
import { forceRedirect } from '@/methods/forceRedirect'
import { Illustration } from '@/components/Illustration/Illustration'

export const ErrorEnpalPage = observer(() => {
  const store = useContext(StoreContext)
  const { errorPage: trans } = store.TranslationsState.translations
  const transContent = trans.errorTransactionCancelled

  if (!transContent) {
    forceRedirect('/error')
    return <></>
  }

  return (
    <div className="page-container mobile-m-0">
      <Illustration type="error" />
      <Header className="m-0-0-30">{transContent.title}</Header>
      <p className="generic__paragraph-centered m-0-0-30">{transContent.dearCustomer}</p>

      <div className="enpal__step">
        <div className="npal__circle">1</div>
        <div className="enpal__info-text">{transContent.step1}</div>
      </div>
      <div className="generic__spacer h-8" />
      <div className="enpal__step">
        <div className="npal__circle">2</div>
        <div className="enpal__info-text">{transContent.step2}</div>
      </div>
    </div>
  )
})
